module.exports = __webpack_public_path__ + "img/noalogo.6ac11237.png";